module.exports = __webpack_public_path__ + "static/media/icon-lighting.06093195.svg";